//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { markAsRead } from '~/utils/importantAnnounceRead'

export default {
  name: 'NewsDetailPage',

  layout: 'page',

  data() {
    return {
      date: '',
      title: '',
      content: null,
      floors: [],
      isShowAllFloors: false,
    }
  },

  mounted() {
    const { id } = this.$route.query

    this.fetchDetail(id)
  },

  methods: {
    async fetchDetail(id) {
      const res = await this.$axios.$get('/news/detail', {
        params: {
          id,
        },
      })

      const {
        date,
        title,
        content,
        floors,
        is_important: isImportant,
      } = res.data

      this.date = date
      this.title = title
      this.content = content
      this.floors = floors

      // 重要フラグが立っているお知らせのみ既読管理
      if (isImportant && this.$auth?.user?.cid) {
        markAsRead(this.$auth.user.cid, Number(id))
      }
    },
    showAllFloors() {
      this.isShowAllFloors = !this.isShowAllFloors
    },
  },
}
